<template>
	<div class="d-flex flex-column align-items-between" style="height: 100%">
		<main class="container my-auto">
			<slot />
		</main>
		
	</div>
</template>
